import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';

import {
  Container,
  Segment,
  Dimmer,
  Loader,
  Menu,
  Icon
} from 'semantic-ui-react';

import { getPageData } from '_utils';
import Pagination from '_views/pagination';
import APITokenItem from './token';
import AddAPITokenModal from './addToken';

const APITokensPage = ({
  apitokensPage,
  display,
  goToPage,
  onCreateAPIToken,
  onRegenerateAPIToken,
  onRefreshAPITokenList,
  onRemoveAPIToken
}) => {

  const {
    items,
    request,
    total,
    pageNum,
    perPage
  } = getPageData([], apitokensPage);

  // const createToken = () => {
  //   if (window.confirm("Would you like to generate a new API Auth Token?")) {
  //     post('/apitokens', {})
  //       .then(body => {
  //         if (onCreateAPIToken) onCreateAPIToken(body);
  //       });
  //   }
  // }

  const onRegenerateToken = (token) => {
    if (window.confirm(`Are you sure you want to regenerate the API Token '${token.name}' and mark previously generated versions useless? This action cannot be reverted.`)) {
      onRegenerateAPIToken({ tokenId: token._id });
    }
  };

  const onRemoveToken = (token) => {
    if (window.confirm(`Are you sure you want to remove the API Token '${token.name}'? This action cannot be reverted.`)) {
      onRemoveAPIToken({ tokenId: token._id });
    }
  };

  return (
    <Container textAlign='left' fluid style={ display ? {} : { display: 'none' } }>
      <Menu icon='labeled' secondary size='small'>
        <Menu.Menu position='right'>
          <Menu.Item name='refresh' onClick={() => onRefreshAPITokenList(R.pathOr({}, ['navigation'], apitokensPage)) } >
            <Icon name='refresh' />
            Refresh
          </Menu.Item>
          <AddAPITokenModal onCreate={ onCreateAPIToken } />
        </Menu.Menu>
      </Menu>
      <Pagination
        goToPage={ goToPage }
        pageNum={ pageNum }
        perPage={ perPage }
        total={ total }
      />
      <Segment basic>
        <Dimmer inverted active={request.isLoading === true}>
          <Loader />
        </Dimmer>
        {
          items.map(t => (
            <APITokenItem
              key={ t._id }
              token={ t }
              onRegenerateToken={ onRegenerateToken }
              onRemoveToken={ onRemoveToken }
              isLoading={ request.isLoading === t._id }
            />
          ))
        }
      </Segment>
    </Container>
  )
}

APITokensPage.propTypes = {
  apitokensPage: PropTypes.object.isRequired,
  display: PropTypes.bool.isRequired,
  goToPage: PropTypes.func.isRequired,
  onCreateAPIToken: PropTypes.func.isRequired,
  onRegenerateAPIToken: PropTypes.func.isRequired,
  onRemoveAPIToken: PropTypes.func.isRequired,
  onRefreshAPITokenList: PropTypes.func.isRequired,
};

export default APITokensPage



// WEBPACK FOOTER //
// ./webAdmin/components/apitokens/page.js